// extracted by mini-css-extract-plugin
export default {"paper":"TitleTrustReviewSection_paper__3lEGz","radios":"TitleTrustReviewSection_radios__dCsPk"};